import SendMessage from './styled';

export default SendMessage;
